import { FaRegCheckCircle } from 'react-icons/fa';
import { MdErrorOutline } from 'react-icons/md';

import styled from 'styled-components';

export const Title = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
  line-height: 1.5;
  font-weight: 600;
  padding-bottom: 5px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.travelDetails.color};
  padding-bottom: 22px;
`;

export const PricePerDay = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.travelDetails.color};
  line-height: 1.67;
  padding-bottom: 5px;
`;

export const TotalPrice = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
  line-height: 1.2;
  padding-bottom: 18px;
`;

export const Card = styled.div`
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.travelDetails.cardShadow};
  margin: 20px 0;
  padding: 24px;
  position: relative;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin: 0 -16px;
  position: absolute;
  border-bottom: solid 1px ${({ theme }) => theme.travelDetails.border};
`;

export const AmenitiesArea = styled.ul`
  padding-top: 8px;
  list-style: disc;
  list-style-position: inside;
`;
export const AmenityItem = styled.li`
  padding-bottom: 10px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
`;

export const ContentRefundableItems = styled.div`
  display: flex;
`;

export const TextIsRefundable = styled.span`
  font-size: 14px;
  align-items: center;
  line-height: 1.43;
  margin-left: 6px;
  color: ${({ theme }) => theme.travelDetails.refundable};
`;

export const TextIsNotRefundable = styled.span`
  font-size: 14px;
  align-items: center;
  line-height: 1.43;
  color: ${({ theme }) => theme.travelDetails.nonRefundable};
`;

export const RefundableIcon = styled(FaRegCheckCircle)`
  font-size: 14px;
  color: ${({ theme }) => theme.travelDetails.green} !important;
  margin-top: 4px;
  @media (min-width: 446px) {
    align-self: center;
    margin-top: 0;
  }
`;

export const NonRefundableIcon = styled(MdErrorOutline)`
  vertical-align: middle;
  margin-bottom: 2px;
  margin-right: 6px;
  font-size: 14px;
  color: ${({ theme }) => theme.travelDetails.red} !important;
`;

export const ColombiaTax = styled.p`
  padding-top: 24px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
`;


export const PayAtDestination = styled.div`
  height: 20%;
  display: flex;
  align-items: center;
  margin-top: 4px;
`;

export const PayAtDestinationText = styled.div`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  font-size: 14px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor} !important;
  margin-top: 4px;
  margin-right: 6px;
  @media (min-width: 446px) {
    align-self: center;
    margin-top: 0;
  }
`;